import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<a
    [attr.title]="data?.appTitle"
    enTooltip
    [routerLink]="insightsRouterLink"
    [queryParams]="insightsQueryParamsRouterLink"
    (click)="$event.stopPropagation()"
  >
    <div class="d-flex align-items-center">
      <div class="title">{{ data?.appTitle }}</div>
    </div>
  </a>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppNameOnlyComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  ngOnInit(): void {
    super.ngOnInit();
  }
}
